// ContactUs.jsx
import React from "react";
import { HiMail, HiPhone } from "react-icons/hi";
import {
  FaWhatsapp,
  FaLinkedin,
  FaInstagram,
  FaArrowRight,
} from "react-icons/fa";
import "./Contact.scss";

const ContactUs = () => {

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="contact-hero__content">
          <h1>Let's Transform Your Institution Together</h1>
          <p>
            Book a personalized demo or get in touch with our experts to discuss
            how Lancehawks ERP can revolutionize your educational institution's
            operations.
          </p>
        </div>
        <div className="contact-stats">
          <div className="stat-item">
            <span className="number">5000+</span>
            <span className="label">People Trust Us</span>
          </div>
          <div className="stat-item">
            <span className="number">99%</span>
            <span className="label">Customer Satisfaction</span>
          </div>
          <div className="stat-item">
            <span className="number">24/7</span>
            <span className="label">Support Available</span>
          </div>
        </div>
      </div>

      {/* Main Contact Section */}
      <div className="contact-section">
        <div className="contact-grid-single">
          {/* Contact Information */}
          <div className="contact-info">
            <div className="info-header">
              <h2>Contact Information</h2>
              <p>Reach out through any of these channels</p>
            </div>

            <div className="info-cards">
              <a
                href="https://wa.me/919915697333"
                target="_blank"
                rel="noopener noreferrer"
                className="info-card"
              >
                <div className="icon-wrapper">
                  <FaWhatsapp className="icon" />
                </div>
                <div className="content">
                  <h3>Whatsapp Us</h3>
                  <p>+91 991 569 7333</p>
                  <p className="subtitle">Get instant information</p>
                </div>
              </a>

              <a href="tel:+919915697333" className="info-card">
                <div className="icon-wrapper">
                  <HiPhone className="icon" />
                </div>
                <div className="content">
                  <h3>Call Us</h3>
                  <p>+91 991 569 7333</p>
                  <p className="subtitle">Mon-Fri, 9am-6pm</p>
                </div>
              </a>

              <a href="mailto:contact@lancehawks.com" className="info-card">
                <div className="icon-wrapper">
                  <HiMail className="icon" />
                </div>
                <div className="content">
                  <h3>Email Us</h3>
                  <p>contact@lancehawks.com</p>
                  <p className="subtitle">24/7 Support Available</p>
                </div>
              </a>
            </div>

            <div className="connect-section">
              <h3>Connect With Us</h3>
              <div className="social-links">
                <a
                  href="https://www.linkedin.com/company/lancehawks/"
                  className="social-link"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://www.instagram.com/lancehawks.tech"
                  className="social-link"
                >
                  <FaInstagram />
                </a>
                <a href="https://wa.me/919915697333" className="social-link">
                  <FaWhatsapp />
                </a>
                <a href="https://lancehawks.com/" className="social-link">
                  Lancehawks
                </a>
              </div>
            </div>
          </div>

          {/* Additional Information Section */}
          <div className="additional-info">
            <div className="info-header">
              <h2>Why Choose Lancehawks ERP?</h2>
              <p>Transform your institution with our comprehensive solutions</p>
            </div>
            
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <FaArrowRight />
                </div>
                <h3>Easy Integration</h3>
                <p>Seamlessly integrate with your existing systems and workflows</p>
              </div>
              
              <div className="feature-card">
                <div className="feature-icon">
                  <FaArrowRight />
                </div>
                <h3>24/7 Support</h3>
                <p>Round-the-clock technical support and customer service</p>
              </div>
              
              <div className="feature-card">
                <div className="feature-icon">
                  <FaArrowRight />
                </div>
                <h3>Scalable Solution</h3>
                <p>Grow with confidence - our system scales with your institution</p>
              </div>
              
              <div className="feature-card">
                <div className="feature-icon">
                  <FaArrowRight />
                </div>
                <h3>Data Security</h3>
                <p>Enterprise-grade security to protect your sensitive information</p>
              </div>
            </div>
            
            <div className="cta-section">
              <h3>Ready to Get Started?</h3>
              <p>Contact us today to schedule your personalized demo and see how Lancehawks ERP can transform your institution.</p>
              <div className="cta-buttons">
                <a href="https://wa.me/919915697333" className="cta-button primary">
                  <FaArrowRight /> Schedule Demo
                </a>
                <a href="tel:+919915697333" className="cta-button secondary">
                  Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Map Section */}
      {/* <div className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3168.6666953190343!2d-122.08624618469637!3d37.42199997982362!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb7e2c147e6ef%3A0x86c3438a1e29d412!2sSilicon%20Valley!5e0!3m2!1sen!2sus!4v1645556727658!5m2!1sen!2sus"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div> */}
    </div>
  );
};

export default ContactUs;
